// Утилиты для работы с адресами.

// Разбирает адрес из объекта API или строки в структурированные поля.
// Возвращает { city, street, house, index, regionCode }.
export function parseAddress(value) {
  if (!value) return { city: "", street: "", house: "", index: "", regionCode: "" };

  if (typeof value === "object") {
    if (value.address || value.address_text || value.full_address) {
      const parsedAddress = parseAddress(value.address || value.address_text || value.full_address);
      return {
        ...parsedAddress,
        index:      value.index || value.postal_code || value.postalCode || parsedAddress.index,
        regionCode: addressRegionCode(value) || parsedAddress.regionCode,
      };
    }
    return {
      city:       value.city        || value.city_name  || value.locality    || "",
      street:     value.street      || value.street_name                      || "",
      house:      value.house       || value.house_number                     || "",
      index:      value.index       || value.postal_code || value.postalCode  || "",
      regionCode: addressRegionCode(value),
    };
  }

  const parts = String(value).trim().split(",").map((p) => p.trim()).filter(Boolean);
  const indexedParts = stripPostalCode(parts);
  const city = findAddressPart(indexedParts.parts, /^(г\.?|город)\s+/i, indexedParts.parts[0] || "");
  const street = findAddressPart(indexedParts.parts, /^(ул\.?|улица)\s+/i, indexedParts.parts[1] || "");
  const house = findAddressPart(indexedParts.parts, /^(д\.?|дом)\s+/i, indexedParts.parts[2] || "");

  return {
    city:       city.replace(/^(г\.?|город)\s+/i, ""),
    street:     street.replace(/^(ул\.?|улица)\s+/i, ""),
    house:      house.replace(/^(д\.?|дом)\s+/i, ""),
    index:      indexedParts.index,
    regionCode: "",
  };
}

function stripPostalCode(parts) {
  if (/^\d{6}$/.test(parts[0] || "")) {
    return { index: parts[0], parts: parts.slice(1) };
  }
  return { index: "", parts };
}

function findAddressPart(parts, marker, fallback) {
  return parts.find((part) => marker.test(part)) || fallback;
}

export function addressRegionCode(value) {
  return value.region_code || value.regionCode || regionCodeFromKladrId(value.region_kladr_id) || "";
}

export function regionCodeFromKladrId(value) {
  const match = String(value || "").match(/^\d{2}/);
  return match ? match[0] : "";
}
